module.exports = __webpack_public_path__ + "img/xander-1-analitico.6efecb09.png";